import { IMenuItem } from "@aecom/core";
import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@bbj/components";
import LoadingService from "@services/loading.service";
import LocalContractService from "@services/local-contract.service";
import NavService from "@services/nav.service";
import { PreviousRouteService } from "@services/previousRoute.service";
import RouteParams from "@shared/route-params";
import {
  appitems,
  productMaintitle,
  productName,
  productSubtitle,
} from "@shared/staticValue";
import environment from "src/environments/environment";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
  standalone: false
})
export default class ErrorComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  authService = inject(AuthService);
  navService = inject(NavService);
  private loadingService = inject(LoadingService);
  private localContractServices = inject(LocalContractService);
  private previousRouteService = inject(PreviousRouteService);

  icon: string;

  title: string;

  contents: string[];

  supportEmail: string;

  buttonText: string;

  copyRight: string;

  showButtonAndContact: boolean;

  productname = productName;

  productsubtitle = productSubtitle;

  productmaintitle = productMaintitle;

  appItems: IMenuItem[] = appitems;

  ngOnInit(): void {
    const url = this.previousRouteService.getPreviousUrl();
    console.log(url);
    const errorCode =
      this.activatedRoute.snapshot.params[RouteParams.ErrorCode];
    this.supportEmail = "support@bbjnyc.com";
    this.copyRight = "© Designed by AECOM Digital Solutions | NYC BBJ PROGRAM ";
    this.showButtonAndContact = true;
    this.buttonText = "RETURN HOME";

    switch (errorCode) {
      case "400":
        this.icon = "icon icon-action_ban icon-blue icon-xl";
        this.title = "400 - Bad request";
        this.buttonText = "REFRESH";
        this.contents = [
          "This page isn’t working at the moment.",
          "If the problem continues, contact the admin.",
        ];
        break;
      case "401":
        this.icon = "icon icon-action_ban icon-blue icon-xl";
        this.title = "You dont have Access";
        this.contents = ["Please contact administrator for more information"];
        break;
      case "403":
        this.icon = "icon icon-basic_eye_closed icon-blue icon-xl";
        this.title = "403 - Forbidden";
        this.contents = ["You don’t have permission to access this page."];
        break;
      case "404":
        this.icon = "icon icon-basic_magnifier icon-blue icon-xl";
        this.title = "404 - Not Found";
        this.contents = [
          "The page you are looking for might have been removed,",
          "had its name changed or is temporaily unavailale.",
        ];
        break;
      case "422":
        this.icon = "icon icon-action_ban icon-blue icon-xl";
        this.title = "The request was unable to be processed.";
        this.contents = [
          'To access your tasks, go to "MY ACTIONS" at the top right corner of the home portal page for quick navigation.',
          "Should you need any further assistance, please contact support@bbjnyc.com",
        ];
        this.buttonText = "RETURN HOME";
        break;
      case "500":
        this.icon = "icon icon-action_ban icon-blue icon-xl";
        this.title = "500 - Internal Server Error";
        this.contents = ["Currently unable to handle this request."];
        this.buttonText = "REFRESH";
        break;
      case "502":
        this.icon = "icon icon-action_ban icon-blue icon-xl";
        this.title = "502 - Bad Gateway";
        this.buttonText = "REFRESH";
        this.contents = [
          "The server encountered a temporary error and could not complete your request.",
        ];
        break;
      case "503":
        this.icon = "icon icon-action_ban icon-blue icon-xl";
        this.title = "503 - Service Unavailable";
        this.buttonText = "REFRESH";
        this.contents = [
          "The service you requested is not available at this time.",
        ];
        break;
      default:
        this.icon = "icon icon-action_send icon-blue icon-xl";
        this.title = "COMING SOON";
        this.contents = [
          "We are due to launch our website very soon, so please stay tuned!",
        ];
    }

    this.loadingService.stop();
  }

  refreshPage(): void {
    const contract = this.localContractServices.getItem();
    if (contract) {
      this.router.navigateByUrl(`${contract.Guid}/list`);
    } else {
      window.location.href = environment.url.portal;
    }
  }
}
